<template>
    <v-layout>
      <v-flex xs12 sm12 md12 lg8 offset-lg2>
        <v-container fluid>
          <v-card>
            <v-card-title>
              <h3 class="headline pa-1">Usuaris</h3>
              <v-spacer></v-spacer>
              <v-text-field
                append-icon="search"
                :label="$t('forms.SEARCH')"
                single-line
                hide-details
                v-model="search"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              v-bind:headers="headers"
              v-bind:search="search"
              :items="orderedUsersList"
              hide-actions
              class="elevation-1">
              <template slot="items" slot-scope="props">
                <td>{{props.item.surname1 + ' ' + props.item.surname2}}</td>
                <td class="text-xs-right">{{props.item.name}}</td>
                <td class="text-xs-right">{{props.item.username}}</td>
                <td class="text-xs-right">{{$t('role.'+findItemById(roles, props.item.roleId).name)}}</td>
                <td class="text-xs-right"><v-btn icon v-on:click="$router.push({ name: 'User', params: {userId: props.item.id} })"><v-icon>edit</v-icon></v-btn></td>
                <td class="text-xs-right">
                  <v-icon v-if="props.item.enabled">lock_open</v-icon>
                  <v-icon v-else>lock</v-icon>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </v-flex>
      <v-btn fab large bottom right fixed class="warning" @click.native="$router.push({name: 'NewUser'})"><v-icon>add</v-icon></v-btn>
      <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Home' })"><v-icon>arrow_back</v-icon></v-btn>
    </v-layout>
</template>

<script>
  import {UserResource} from '../../api/user'
  import {RoleResource} from '../../api/role'
  export default {
    name: 'users',
    data () {
      return {
        variable: 'value',
        search: '',
        usersList: [],
        roles: [],
        sortOptions: {
          orderField: 'surname',
          direction: 'asc'
        },
        headers: [
          {
            text: this.$t('headers.users.SURNAME'),
            align: 'left',
            value: 'surname'
          },
          { text: this.$t('headers.users.NAME'), value: 'name' },
          { text: this.$t('headers.users.EMAIL'), value: 'username' },
          { text: this.$t('headers.users.TYPE'), value: 'userType' }
        ]
      }
    },
    created () {
      RoleResource().get().then(
        response => {
          this.roles = response.data
        },
        response => {
          console.log('error in roles endpoint')
        }
      )
    },
    mounted () {
      UserResource().get().then(response => {
        this.usersList = response.body
      }, response => {

      })
    },
    computed: {
      orderedUsersList: function () {
        return this._.orderBy(this.usersList, this.sortOptions.orderField, this.sortOptions.direction)
      }
    },
    methods: {
      findItemById: function (collection, itemId) {
        return this._.find(collection, function (i) {
          return i.id === itemId
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/Users.vue